<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="800px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="finalColumnDefs"
        :row-data="finalRowData"
        style="width:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <span slot="footer" style="padding-right:30px">
      <el-upload
        action
        multiple
        :auto-upload="false"
        :show-file-list="false"
        :on-change="toChooseFile"
        style="float:left;margin-left:30px;margin-right:13px"
      >
        <el-button v-show="$checkPermission(['button_ContractManagement_editContract'])" type="primary">{{ $t('Message.SelectFile') }}</el-button>
      </el-upload>
      <el-button v-show="$checkPermission(['button_ContractManagement_editContract'])" type="danger" style="float:left" @click="remove()">{{ $t('Message.DeleteFile') }}</el-button>
      <el-button v-show="!submitIsEnable" type="primary" @click="upload()">{{ $t('Message.Upload') }}</el-button>
      <el-button v-show="submitIsEnable" type="primary" @click="submit()">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
    <!-- 文档类别弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="docTypeTree.visible"
      :title="$t('Message.Edit')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="docTypeTree.gridOptions"
          :row-data="docTypeTree.rowData"
          style="width:350px;height:300px;padding-left:2px"
          @gridReady="params=>docTypeTree.gridApi=params.api"
        />
      </div>
      <span slot="footer" style="padding-right:30px">
        <el-button type="primary" @click="saveDocType()">{{ $t('common.btn.ok') }}</el-button>
        <el-button @click="docTypeTree.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import { getAllUsersByOffice, getDropdownUser } from '@/api/user'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { uploadStorage } from '@/api/storage'
import { getBusinessDocumentList, saveBusinessDocument, delBusinessDocument } from '@/api/businessDocument'
import { getOfficeUserList, getUserById } from '@/api/user'
import lang from '@/lang'
import URL from '@/api/urlTranslator'

export default {
  name: 'CargoFileUploadDialog',
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, default: lang.t('Message.UploadFile') },
    documentCategory: { type: Number, default: 0 },
    businessId: { type: String, required: true },
    showFileCategory: { type: Boolean, default: false },
    lob: { type: String, default: '' },
    parameters: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      userList: [],
      userMap: new Map(),
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Message.FileName'),
          colId: 'fileName',
          field: 'fileName',
          suppressMenu: true,
          width: 175,
          cellRenderer: params => {
            // if (params.data.documentId) {
            return `<a href="${URL.common.findByFileId}/${params.data.documentId || 'null'}?sessionId=${this.user.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
            // } else {
            //   return params.value
            // }
          }
        },
        {
          headerName: this.$t('Message.FileType'),
          colId: 'fileType',
          field: 'fileType',
          suppressMenu: true,
          width: 90
        },
        {
          headerName: this.$t('Message.FileSize'),
          colId: 'fileSize',
          field: 'fileSize',
          suppressMenu: true,
          width: 90,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('Message.Uploader'),
          colId: 'createdBy',
          field: 'createdBy',
          suppressMenu: true,
          width: 90,
          cellRenderer: params => {
            return this.userMap.get(params.value)
          }
        },
        {
          headerName: this.$t('Message.UploadTime'),
          colId: 'dateCreated',
          field: 'dateCreated',
          suppressMenu: true,
          width: 90,
          cellRenderer: params => {
            return params.value ? params.value.substr(0, 10) : ''
          }
        },
        {
          headerName: this.$t('Message.UploadProgress'),
          colId: 'uuid',
          field: 'uuid',
          suppressMenu: true,
          width: 90,
          cellRenderer: params => {
            if (params.data.uuid || params.data.documentId) {
              return '<span style="color:#67C23A">上传完成</span>'
            }
            if (this.uploading) {
              return this.$t('Message.Uploading2')
            }
            return this.$t('Message.WaitingForUpload')
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      docTypeTree: {
        visible: false,
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Message.DocumentCategory'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked ? 'checkbox-checked' : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                if (checked) {
                  this.docTypeTree.rowData.forEach(item => {
                    item.checked = false
                  })
                }
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      docTypeMap: new Map(),
      uploading: false
    }
  },
  computed: {
    finalColumnDefs() {
      if (this.showFileCategory) {
        return [
          ...this.columnDefs,
          {
            headerName: this.$t('Message.DocumentCategory'),
            colId: 'fileCategory',
            field: 'fileCategory',
            suppressMenu: true,
            width: 90,
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('showDocTypeTree')
              const text = this.docTypeMap.get(params.value.toUpperCase()) || '&nbsp;'
              return `<div onclick="${methodPath}(${params.data.seq})" style="cursor:pointer">${text}</div>`
            }
          }
        ]
      } else {
        return this.columnDefs
      }
    },
    finalRowData() {
      return this.rowData.filter(p => p.todo !== 'remove')
    },
    submitIsEnable() {
      return this.rowData.filter(p => p.todo === 'new' && !p.documentId).length === 0
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    },
    showFileCategory(newVal) {
      if (newVal) {
        this.buildDocTypeTree()
      }
    }
  },
  async created() {
    await getAllUsersByOffice({ officeId: this.$store.getters.currentOfficeId }).then(res => {
      this.userList = res.data
      for (const item of this.userList) {
        this.userMap.set(item.userId, item.chineseName)
      }
    })
    if (this.showFileCategory) {
      await this.buildDocTypeTree()
    }
    if (this.visible) {
      this.innerVisible = true
      await this.initData()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showDocTypeTree', function(seq) {
      context.showDocTypeTree(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      await getBusinessDocumentList({ documentCategory: this.documentCategory, businessId: this.businessId }).then(res => {
        res.data.forEach(item => {
          item.seq = this.autoIncrementNum.getNextNum()
          item.airExportLoadingNotesUuid = item.airExportLoadingNotesUuid || null
          item.warehouseInUuid = item.warehouseInUuid || null
          item.customsInfoUuid = item.customsInfoUuid || null
          item.airExportFlightCustomerUuid = item.airExportFlightCustomerUuid || null
        })
        this.rowData = res.data
      })
      // 将userMap中不存在的上传人加入userMap
      await this.supplementUserMap()
    },
    // 将userMap中不存在的上传人加入userMap
    async supplementUserMap() {
      for (const row of this.rowData) {
        if (!this.userMap.has(row.createdBy)) {
          await getUserById(row.createdBy).then(resp => {
            if (resp.data && resp.data.type === 1) {
              this.userMap.set(row.createdBy, '平台客服')
            } else {
              this.userMap.set(row.createdBy, resp.data.chineseName)
            }
          })
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    buildDocTypeTree() {
      return getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.lob }).then(res => {
        const data = res.data.filter(p => {
          const pathArr = p.path.split(',')
          if (p.type === 1) {
            return pathArr.length === 1
          }
          if (p.type === 2) {
            return pathArr.length > 1
          }
          return false
        })
        data.forEach(item => {
          item.checked = false
          if (item.type === 2) {
            this.docTypeMap.set(item.code.toUpperCase(), item.chineseName)
          }
        })
        this.docTypeTree.rowData = data
      })
    },
    async toChooseFile(file) {
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      this.rowData.push({
        seq: this.autoIncrementNum.getNextNum(),
        uuid: '',
        documentId: '',
        documentCategory: this.documentCategory,
        fileName,
        fileType,
        fileSize: file.size,
        createdBy: this.user.userId,
        dateCreated: '',
        businessId: this.businessId,
        fileCategory: '',
        file: file.raw,
        todo: 'new'
      })
      await this.supplementUserMap()
    },
    showDocTypeTree(seq) {
      const rows = this.finalRowData.filter(p => p.seq === seq)
      if (rows.length === 0) {
        return
      }
      const fileCategory = rows[0].fileCategory.toUpperCase()
      this.docTypeTree.rowData.forEach(item => {
        if (item.code.toUpperCase() === fileCategory) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      if (this.docTypeTree.gridApi) {
        this.docTypeTree.gridApi.refreshCells({ force: true })
      }
      this.docTypeTree.visible = true
    },
    saveDocType() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const currentRow = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
      const docTypeRows = this.docTypeTree.rowData.filter(p => p.type === 2 && p.checked)
      if (docTypeRows.length > 0) {
        currentRow.fileCategory = docTypeRows[0].code
      } else {
        currentRow.fileCategory = ''
      }
      if (!currentRow.todo) {
        currentRow.todo = 'edit'
      }
      this.gridApi.refreshCells({ force: true })
      this.docTypeTree.visible = false
    },
    remove() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        row.todo = 'remove'
        this.rowData = [...this.rowData]
      }).catch(() => { })
    },
    upload() {
      const uploadRows = this.rowData.filter(p => p.todo === 'new' && !p.documentId)
      const dateCreated = this.getFormatDate()
      this.uploading = true
      this.gridApi.refreshCells({ force: true })
      Promise.all(
        Array.from(
          uploadRows,
          p => uploadStorage(Object.assign({ file: p.file }, this.parameters)).then(res => {
            p.documentId = res.data
            p.createdBy = this.user.userId
            p.dateCreated = dateCreated
          })
        )
      ).then(results => {
        this.rowData = [...this.rowData]
        this.uploading = false
      })
    },
    getFormatDate() {
      const now = new Date()
      let month = now.getMonth() + 1
      let day = now.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return `${now.getFullYear()}-${month}-${day}`
    },
    async submit() {
      const uploadSuccessCount = this.rowData.filter(p => p.todo === 'new' && p.documentId).length
      const uploadFailCount = this.rowData.filter(p => p.todo === 'new' && !p.documentId).length
      if (uploadFailCount > 0) {
        const isOk = await this.$confirm(this.$t('Message.SuccessfulFailure0ConfirmSave', [uploadSuccessCount, uploadFailCount]), '确认', {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!isOk) {
          return
        }
      }
      const saveRows = this.rowData.filter(p => p.todo === 'new' || p.todo === 'edit')
      const removeRows = this.rowData.filter(p => p.todo === 'remove' && p.uuid)
      try {
        await Promise.all([
          ...Array.from(saveRows, p => saveBusinessDocument(p)),
          ...Array.from(removeRows, p => delBusinessDocument(p.uuid))
        ])
      } finally {
        // 与产品沟通 仅删除需要触发合同两个状态计算
        if (removeRows && removeRows.length > 0) {
          this.$emit('uploadDone', this.businessId)
        } else {
          this.$emit('uploadDone')
        }
        this.innerVisible = false
      }
    }
  }
}
</script>

<style>
</style>
